// authentication constants

export const GET_USER_SUCCESS = "GET_USER_SUCCESS";

export const GET_USER_FAILURE = "GET_USER_FAILURE";

export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";

export const REGISTER_USER_FAILURE = "REGISTER_USER_FAILURE";

export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";

export const LOGIN_USER_FAILURE = "LOGIN_USER_FAILURE";

export const LOGOUT_USER = "LOGOUT_USER";

export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";

export const LOAD_USER_FAILURE = "LOAD_USER_FAILURE";

export const CLEAR_ERROR = "CLEAR_ERROR";

export const START_LOADING = "START_LOADING";

export const LOGIN_WITH_GOOGLE = "LOGIN_WITH_GOOGLE";

// data constants

export const DATA_LOADING = "DATA_LOADING";

export const DATA_UPLOADING = "DATA_UPLOADING";

export const DATA_PROCESSING = "DATA_PROCESSING";

export const IMAGE_LOADING = "IMAGE_LOADING";

export const IMAGE_UPLOADING = "IMAGE_UPLOADING";

export const IMAGE_PROCESSING = "IMAGE_PROCESSING";

export const UPLOAD_DATA_SUCCESS = "UPLOAD_DATA_SUCCESS";

export const UPLOAD_DATA_FAILURE = "UPLOAD_DATA_FAILURE";

export const PROCESS_DATA_SUCCESS = "PROCESS_DATA_SUCCESS";

export const PROCESS_DATA_FAILURE = "PROCESS_DATA_FAILURE";

export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";

export const UPLOAD_IMAGE_FAILURE = "UPLOAD_IMAGE_FAILURE";

export const PROCESS_IMAGE_SUCCESS = "PROCESS_IMAGE_SUCCESS";

export const PROCESS_IMAGE_FAILURE = "PROCESS_IMAGE_FAILURE";

export const CLEAR_IMAGE_DATA = "CLEAR_IMAGE_DATA";

export const CSV_DATA_SUCCESS = "CSV_DATA_SUCCESS";

export const CSV_DATA_FAILURE = "CSV_DATA_FAILURE";

export const INCREMENT_FAIL_COUNT = "INCREMENT_FAIL_COUNT";

export const RESET_FAIL_COUNT = "RESET_FAIL_COUNT";

// canvas

export const STORE_CANVAS = "STORE_CANVAS";

export const LOAD_CANVAS = "LOAD_CANVAS";
